export const getIframeAdjustedCoords = (iFrameWindow, clientX, clientY) => {
    const { x, y } = iFrameWindow.current.getBoundingClientRect();
    return {
        clientX: clientX + x,
        clientY: clientY + y,
    };
};
//# sourceMappingURL=helper.js.map